import React from 'react';
import { Button, Input } from '../../../ui';

type AuthRecoveryStepViewProps = {
    email: string;
    error?: string;
    isLoading?: boolean;
    onEmailChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onSubmit: () => void;
};

export const AuthRecoveryStepView: React.FC<AuthRecoveryStepViewProps> = ({
    email,
    error,
    isLoading,
    onEmailChange,
    onSubmit,
}) => (
    <div
        id="auth-recovery-step"
        className="flex flex-col mt-8 w-full min-h-[412px]"
        data-testid="recovery-step"
    >
        <div
            id="auth-recovery-heading"
            className="text-body-large text-primary mb-1"
        >
            Recover your password
        </div>
        <div
            id="auth-recovery-instructions"
            className="text-body-small text-secondary mb-6"
        >
            Enter the email address you used to sign up
        </div>
        <Input
            id="auth-recovery-email"
            label="Email Address"
            value={email}
            onChange={onEmailChange}
            type="email"
            className="mb-3"
            error={!!error}
            helperText={error}
            data-testid="recovery-email"
        />
        <div
            id="auth-recovery-email-description"
            className="text-body-xsmall text-secondary mb-auto"
        >
            We will send you instructions to reset your password
        </div>
        <Button
            id="auth-recovery-submit-button"
            type="button"
            className="w-full mt-6"
            loading={isLoading}
            disabled={!email}
            onClick={onSubmit}
            data-testid="recovery-submit"
        >
            Reset Password
        </Button>
    </div>
);
